import { MONEY_MULTIPLIER } from '../constants/pestoConstants';

export const centsToDecimal = (cents: number): string => {
  return (cents / MONEY_MULTIPLIER).toFixed(2);
};

export const parseDollarString = (dollars: string): number => {
  const cleaned = dollars.replace(/[$,]/g, '');
  const parsed = Number(cleaned);

  return Number.isFinite(parsed) ? parsed : 0;
};

export const decimalToCents = (decimal: string): number => {
  return Math.round(parseDollarString(decimal) * MONEY_MULTIPLIER);
};

const compactUsdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
});

export const formatCompactUsd = (value: number): string => compactUsdFormatter.format(value);
